// extracted by mini-css-extract-plugin
module.exports = {"textArea":"textArea_textArea__ig3tY","modal":"textArea_modal__17V6q"};